import React, { useState } from "react";
import contact from "../assets/contact.png";
import { AiOutlineCheckCircle } from "react-icons/ai"; // Importing the green tick mark icon
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false); // New state for dialog visibility
  const [error, setError] = useState(""); // State to store error messages

  const handleChange = (e) => {
    const { name, value } = e.target;

    // If the user is typing in the mobile field, validate the input
    if (name === "mobile") {
      // Only allow numeric characters and ensure the length is not greater than 10
      if (/[^0-9]/.test(value)) {
        return; // If a non-numeric character is entered, do nothing
      }

      // Set the form data
      setFormData({ ...formData, [name]: value });

      // Validate if the mobile number has exactly 10 digits
      if (value.length === 10) {
        setError(""); // Reset error if the input is valid
      } else {
        setError("Please enter exactly 10 numeric digits.");
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Ensure the mobile number is valid before submitting
    if (formData.mobile.length !== 10) {
      setError("Please enter exactly 10 numeric digits.");
      return; // Prevent form submission if validation fails
    }

    // Reset error message if validation passes
    setError("");

    console.log("Form Data Submitted:", formData);

    // Format the WhatsApp link with the pre-filled message
    const phoneNumber = "9160077777"; // Target phone number
    const message = `Name: ${formData.name}\nMobile: ${formData.mobile}\nEmail: ${formData.email}`; // Formatted message

    // Create the WhatsApp URL
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    // Open WhatsApp chat with the pre-filled message
    window.open(whatsappURL, "_blank");

    // Reset form data
    setFormData({
      name: "",
      mobile: "",
      email: "",
    });

    // Display the dialog
    setIsSubmitted(true);

    // Hide the dialog after a few seconds (optional)
    setTimeout(() => {
      setIsSubmitted(false);
    }, 4000);
  };

  return (
    <div>
      {/* <h1 className="text-center mt-5 text-3xl font-bold">Contact Form</h1> */}

      <div className="flex flex-col justify-between mx-auto border my-5 p-5 shadow md:flex-row">
        <div className="flex items-center justify-center bg-[#ffffff] py-[5%]">
          <div className="bg-[#454a44] text-white p-8 rounded-lg shadow-lg w-full max-w-md">
            <div className="text-left">
              <h2 className="text-lg font-semibold text-center">
                We'd Love to Hear From You
              </h2>
              <h1 className="text-2xl font-bold text-center mt-2">
                Get in Touch
              </h1>
            </div>

            <form onSubmit={handleSubmit} className="mt-6">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-2 mb-4 rounded-md border border-gray-300 text-black focus:ring focus:ring-gray-500 focus:outline-none"
                required
              />
              <input
                type="tel"
                name="mobile"
                placeholder="Mobile"
                value={formData.mobile}
                onChange={handleChange}
                className="w-full px-4 py-2 mb-4 rounded-md border border-gray-300 text-black focus:ring focus:ring-gray-500 focus:outline-none"
                required
              />
              {/* Show error message if mobile number is not valid */}
              {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2 mb-4 rounded-md border border-gray-300 text-black focus:ring focus:ring-gray-500 focus:outline-none"
                required
              />
              <button
                type="submit"
                className="w-full bg-[#d9ded8] text-gray-700 py-2 rounded-md font-semibold hover:bg-[#d9ded8]-400 transition"
              >
                Submit
              </button>
            </form>

            <p className="text-[9px] text-gray-400 mt-4 text-center">
              <strong>Disclaimer:</strong> I authorize Siddhi Ganapathi Ventures
              LLP and its representatives to Call, SMS, Email, or WhatsApp me
              about its ventures, investment opportunities, and offers. This
              consent overrides any registration for DNC / NDNC.
            </p>
          </div>
        </div>
        <div>
          <img src={contact} className="py-[5%]" />
          <div>
            {/* Contact Information */}
            <div className="flex flex-col  items-center">
              <div className="flex flex-col sm:flex-row mb-4">
                <strong>Email: </strong>
                <div className="text-[14px]  ml-1 mt-[.7%]">
                  <p>info@siddhiganapathi.com,</p>
                  <p>cmd@siddhiganapathi.com</p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row mt-2 sm:mt-0 mb-2">
                <strong className="">Mobile: </strong>
                <a
                  href="tel:+919160077777"
                  className="text-[14px] ml-1 mt-[.7%]"
                >
                  +91 9160077777, +91 8330077777
                </a>
              </div>

              <div className="flex flex-row sm:flex-row mt-2 sm:mt-0">
                <strong className="flex gap-2">
                  <a href="https://www.instagram.com/accounts/login/?next=%2Fsiddhi_ganapathi%2F&source=omni_redirect">
                    <FaInstagram className="text-2xl" />{" "}
                  </a>{" "}
                  <a href="https://www.facebook.com/people/Siddhi-Ganapathi-Developers-Private-Limited/61574220923381/">
                    <FaFacebook className="text-2xl" />
                  </a>
                </strong>
               
              </div>
            </div>
          </div>
        </div>
        {/* Success Dialog Box */}
        {isSubmitted && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-600 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-sm text-center">
              <AiOutlineCheckCircle className="text-green-500 text-5xl mb-4 text-center" />
              <h3 className="text-xl font-semibold text-gray-700">
                Our team will contact you soon!
              </h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactForm;
